import { render, staticRenderFns } from "./AnnexList.vue?vue&type=template&id=7e5ef66e&"
import script from "./AnnexList.vue?vue&type=script&lang=ts&"
export * from "./AnnexList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports